function verifyStringValue(array, arrayField, id) {
    // Create new array with updated elements instead of mutating
    return array.map((item, index) => {
        // Check if the arrayField contains the condition or if the length of the field is less than 5
        if (item[arrayField] === undefined || 
            (item[arrayField].length < 5) ||
            item[arrayField].includes("undefined")
        ) {
            // If either condition is true, update the arrayField with a new value based on the id and index
            return {
                ...item,
                [arrayField]: (id && id !== '') ? `${id}.${index + 1}` : ''
            };
        }
        return item;
    });
}

const subCheckField = (data, operation) => {

    if (!data[operation.subEntity]) {
        return data
    }

    // Extract the condition, subEntity, and subEntityField from the operation object
    const array = data[operation.subEntity]
    const arrayField = operation.subEntityField

    // Call the verifyStringValue function to verify the arrayField exists and has the right value
    const verifiedArray = verifyStringValue(array, arrayField, data.id)

    // Return new object instead of mutating
    return {
        ...data,
        [operation.subEntity]: verifiedArray
    }
}

export default subCheckField
